// src/features/explore/meta.ts — static tables + types for the Explore page.

/** A chip in the explore chip row: a content-type or a topic id. */
export type ContentType = 'all' | 'posts' | 'people' | 'communities';
export type ExploreView = 'posts' | 'people' | 'communities';
export type FeedTab = 'for-you' | 'trending' | 'popular' | 'latest';
export type ExploreSortId = 'recent' | 'cheers';

export interface ChipDef { id: ContentType; label: string; }
export interface FeedTabDef { id: FeedTab; label: string; }
export interface SortDef { id: ExploreSortId; label: string; }

export const CONTENT_CHIPS: ChipDef[] = [
  { id: 'all',         label: 'All' },
  { id: 'posts',       label: 'Posts' },
  { id: 'people',      label: 'People' },
  { id: 'communities', label: 'Communities' },
];

export const FEED_TABS: FeedTabDef[] = [
  { id: 'for-you',  label: 'For You' },
  { id: 'trending', label: 'Trending' },
  { id: 'popular',  label: 'Popular' },
  { id: 'latest',   label: 'Latest' },
];

export const SORTS: SortDef[] = [
  { id: 'recent', label: 'Most Recent' },
  { id: 'cheers', label: 'Most cherished' },
];
